var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "single-result-search vehicle-component",
      class: _vm.vehicleClasses
    },
    [
      _c(
        "div",
        {
          staticClass: "container-single-result-search",
          on: {
            click: function($event) {
              return _vm.selectVehicle(_vm.vehicle, $event)
            },
            contextmenu: function($event) {
              $event.preventDefault()
              return _vm.tagPopupModal()
            }
          }
        },
        [
          _c("div", { staticClass: "lot" }, [
            _c("div", { staticClass: "lot-no" }, [
              _c("span", { staticClass: "checkbox" }, [
                _c("input", {
                  attrs: {
                    type: "checkbox",
                    id: "select-vehicle-" + _vm.vehicle.api_id
                  },
                  domProps: {
                    checked: _vm.isSelected,
                    value: _vm.vehicle.api_id
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  attrs: { for: "select-vehicle-" + _vm.vehicle.api_id },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                })
              ]),
              _vm._v("\n                Lot No. " + _vm._s(_vm.vehicle.lot)),
              _c("span", { staticClass: "auction-house" }, [
                _vm._v(
                  _vm._s(_vm.displayAuctionHouse(_vm.vehicle.auction_house))
                )
              ])
            ]),
            _vm._v(" "),
            _vm.isRecommendPage && _vm.vehicle.recommended_at
              ? _c(
                  "div",
                  { staticClass: "recommended" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.recommendedTitle,
                          placement: "bottom",
                          effect: "light"
                        }
                      },
                      [
                        _c(
                          "b-badge",
                          { attrs: { pill: "", variant: "light" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.recommendedAgo()) +
                                "\n                    "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "viewed" },
              [
                _vm.vehicle.viewed
                  ? _c("icon", { attrs: { icon: " fa-eye" } })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "image-hover-container" },
            [_c("vehicle-hover-images", { attrs: { vehicle: _vm.vehicle } })],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "image-vehicle" }, [
            _c(
              "a",
              {
                attrs: { href: _vm.vehicle.detail_url },
                on: {
                  click: [
                    function($event) {
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToCar()
                    },
                    function($event) {
                      if ($event.ctrlKey || $event.shiftKey || $event.altKey) {
                        return null
                      }
                      $event.stopPropagation()
                      if (!$event.metaKey) {
                        return null
                      }
                    },
                    function($event) {
                      if ($event.shiftKey || $event.altKey || $event.metaKey) {
                        return null
                      }
                      $event.stopPropagation()
                      if (!$event.ctrlKey) {
                        return null
                      }
                    }
                  ],
                  mouseup: function($event) {
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 1) {
                      return null
                    }
                    $event.stopPropagation()
                  }
                }
              },
              [
                _vm.vehicle.images["front"]
                  ? _c("img", {
                      attrs: {
                        width: "433",
                        height: "325",
                        src: _vm.vehicle.images["front"],
                        alt: "Front",
                        loading: "lazy"
                      }
                    })
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "model" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.vehicle.year) +
                " " +
                _vm._s(_vm.vehicle.make) +
                "\n            "
            ),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.vehicle.model) } }),
            _vm._v(" "),
            _vm.isTranslatedGrade
              ? _c("span", {
                  attrs: {
                    title:
                      "This grade was translated. Original: " +
                      _vm.vehicle.grade
                  },
                  domProps: {
                    innerHTML: _vm._s(_vm.translatedGrades[_vm.vehicle.api_id])
                  }
                })
              : _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.vehicle.grade) }
                })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "price-container",
            domProps: { innerHTML: _vm._s(_vm.convertCurrency(_vm.vehicle)) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "info" }, [
            _c("div", { staticClass: "info-table" }, [
              _c("div", { staticClass: "info-column" }, [
                _c("strong", [_vm._v("Grade:")]),
                _vm._v(" "),
                _c("span", { staticClass: "rating" }, [
                  _vm._v(_vm._s(_vm.vehicle.condition))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-column" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.vehicle.engine_capacity) +
                    "cc\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "info-column" }, [
                _c("span", { staticClass: "mileage" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.numberWithCommas(_vm.vehicle.mileage, 9999)) +
                      "Km\n                    "
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "details" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.vehicle.transmission) +
                " / " +
                _vm._s(_vm.convertEquipment(_vm.vehicle.equipment)) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              class: _vm.timeClasses(_vm.vehicle),
              attrs: { title: _vm.getJapanDiff(_vm.vehicle.auction_date) }
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.getDateTime(_vm.vehicle.auction_date).format("h:mma")
                  ) +
                  " JPN /\n            " +
                  _vm._s(
                    _vm.getNZDateTime(_vm.vehicle.auction_date).format("h:mma")
                  ) +
                  " NZ\n        "
              )
            ]
          ),
          _vm._v(" "),
          _vm.isSold(_vm.vehicle.auction_date)
            ? [
                _vm.vehicle && _vm.vehicle.sold_price
                  ? _c("div", { staticClass: "sold" }, [
                      _c("strong", [_vm._v("Sold")]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "blue",
                          attrs: {
                            title:
                              _vm.numberWithCommas(_vm.vehicle.sold_price) +
                              " yen"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    ¥ " +
                              _vm._s(
                                _vm.numberWithCommas(
                                  _vm.vehicle.sold_price / 1000
                                )
                              ) +
                              " k\n                "
                          )
                        ]
                      )
                    ])
                  : _vm.isSold(_vm.vehicle.auction_date)
                  ? _c(
                      "div",
                      { staticClass: "sold" },
                      [
                        _vm.vehicle.bid_status === "negotiation"
                          ? _c("span", [_vm._v("negotiation")])
                          : _vm.vehicle.bid_status === "cancelled"
                          ? _c("span", [_vm._v("Cancelled")])
                          : _vm.vehicle.bid_status === "sold"
                          ? _c("span", { staticClass: "bid-sold" }, [
                              _vm._v("Sold")
                            ])
                          : _c("span", { staticClass: "bid-not-sold" }, [
                              _vm._v("Not sold")
                            ]),
                        _vm._v(" "),
                        _vm.vehicle.end_price && _vm.vehicle.end_price > 0
                          ? [
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "blue",
                                  attrs: {
                                    title:
                                      _vm.numberWithCommas(
                                        _vm.vehicle.end_price
                                      ) + " yen"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    ¥ " +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          _vm.vehicle.end_price / 1000
                                        )
                                      ) +
                                      " k\n                "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "view-more" }, [
            _c(
              "a",
              {
                staticClass: "link arrow",
                attrs: { href: _vm.vehicle.detail_url },
                on: {
                  click: [
                    function($event) {
                      if (
                        $event.ctrlKey ||
                        $event.shiftKey ||
                        $event.altKey ||
                        $event.metaKey
                      ) {
                        return null
                      }
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToCar()
                    },
                    function($event) {
                      if ($event.ctrlKey || $event.shiftKey || $event.altKey) {
                        return null
                      }
                      $event.stopPropagation()
                      if (!$event.metaKey) {
                        return null
                      }
                    },
                    function($event) {
                      if ($event.shiftKey || $event.altKey || $event.metaKey) {
                        return null
                      }
                      $event.stopPropagation()
                      if (!$event.ctrlKey) {
                        return null
                      }
                    }
                  ],
                  mouseup: function($event) {
                    if (
                      $event.ctrlKey ||
                      $event.shiftKey ||
                      $event.altKey ||
                      $event.metaKey
                    ) {
                      return null
                    }
                    if ("button" in $event && $event.button !== 1) {
                      return null
                    }
                    $event.stopPropagation()
                  }
                }
              },
              [_vm._v("View more")]
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.vehicle.bids, function(bid, element) {
            return _c(
              "div",
              { staticClass: "mt-2", style: _vm.bidColourStyle(bid) },
              [
                element == _vm.vehicle.bids.length - 1
                  ? _c("div", { staticClass: "p-2" }, [
                      _c("div", [
                        _c(
                          "a",
                          {
                            staticClass: "person",
                            attrs: { href: "#!" },
                            on: {
                              click: function($event) {
                                return _vm.filterBidUser(bid.user.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(bid.user.name))]
                        )
                      ]),
                      _vm._v(" "),
                      bid.bid_price_jpy && bid.bid_price_landed
                        ? _c(
                            "div",
                            { staticClass: "d-flex align-items-start" },
                            [
                              _c("div", { staticClass: "mr-2 text-right" }, [
                                _c("div", [_vm._v("Cost")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "text-transform": "uppercase"
                                    }
                                  },
                                  [_vm._v(_vm._s(bid.landed_currency))]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  [
                                    _vm.$userIsAdmin
                                      ? [
                                          _vm._v(
                                            "\n                                ¥ " +
                                              _vm._s(
                                                _vm.numberWithCommas(
                                                  bid.bid_price_jpy +
                                                    bid.bump_bid
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                ¥ " +
                                              _vm._s(
                                                _vm.numberWithCommas(
                                                  bid.bid_price_jpy
                                                )
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(bid.currency_sign) +
                                      " " +
                                      _vm._s(
                                        _vm.numberWithCommas(
                                          bid.bid_price_landed
                                        )
                                      ) +
                                      "\n                        "
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-915fabda", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-915fabda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/Vehicle.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-915fabda","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Common/Vehicle.vue
// module chunks = 0